// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"24":"ca74f497","40":"68dcab47","66":"b2c33332","499":"3bb35855","785":"39d7c1e3","825":"366e9372","938":"b5f64cfc","940":"01a93175"}[chunkId] + ".css";
};